import * as React from 'react';

import { Card } from '@blueprintjs/core';

import CardContainer from '../common/CardContainer';

class ContactsPage extends React.Component<{}> {
    public render() {
        return (
            <>
                <CardContainer height="400px">
                    <Card elevation={1}>
                        <div className="card-header">Contacts</div>
                    </Card>
                </CardContainer>
            </>
        );
    }
}

export default ContactsPage;



// WEBPACK FOOTER //
// ./src/components/contacts/ContactsPage.tsx